import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1a4e08c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "header__right" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

import {computed} from 'vue'
import {useStore} from 'vuex';
import {useI18n} from 'vue-i18n'
import ContentContainer from '@/layout/ContentContainer.vue'
import LanguageSwitcher from '@/components/Base/LanguageSwitcher.vue';
import logoMobileDF from '@/assets/svg/logoMobileDF.svg'
import logoDesktopDF from '@/assets/svg/logoDesktopDF.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const langCode = computed(() => {
  return useI18n().locale
})

const store = useStore()

const logoMobilePartner = computed(() => store.state.pageContent?.mobile_logo?.file ?? '');
const logoDesktopPartner = computed(() => store.state.pageContent?.logo?.file ?? '');

const isMobile = computed(() => window.innerWidth < 1024)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ContentContainer, { class: "header-container" }, {
      default: _withCtx(() => [
        (isMobile.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: logoMobilePartner.value,
              style: {"object-fit":"none"}
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: logoDesktopPartner.value,
              style: {"max-width":"130px","max-height":"100%"}
            }, null, 8, _hoisted_3)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(LanguageSwitcher),
          _createElementVNode("a", {
            href: langCode.value.value == 'pl' ? 'https://delayfix.com/' : 'https://delayfix.com/'+langCode.value.value
          }, [
            (isMobile.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(logoMobileDF),
                  alt: ""
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _unref(logoDesktopDF),
                  alt: ""
                }, null, 8, _hoisted_7))
          ], 8, _hoisted_5)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})